import Header from "../../common/header/DefaultHeader";
import SidebarMenu from "../../common/header/dashboard/SidebarMenu";
import MobileMenu from "../../common/header/MobileMenu";
import { Stack, Container, Row, Col, Form } from "react-bootstrap";
import { useEffect, useState, useCallback, useRef } from "react";
import {
  getBidOfferDetails,
  getCifDetails,
  getBidDetailsById,
  getBuyerFilterDetails,
  getSoldPropertiesDetails,
} from "@/api/bids";
// import PropertyDetailTimer from "@/components/bid/PropertyDetailTimer";
import PropertyDetailsCard from "../MyBids/PropertyDetailsCard/PropertyDetailsCard";
import { ShimmerContentBlock } from "react-shimmer-effects";
import DashboardSectionWrapper from "../components/DashboardSectionWrapper";
import { format } from 'date-fns';
import { userSlice } from "@/redux/user/userSlice";
import "../MyBids/PropertyDetailsCard/PropertyDetailsCard.css"
import { useSelector } from "react-redux";
import SoldProperties from "./SoldProperties";
import { store } from "@/store/store";
import { trackButtonClick } from "@/utils/analytics";
import Loader from "../../common/loader/Loader";


const MyBids = () => {
  const [bidOffers, setBidOffers] = useState(null);
  const [cifData, setCifData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [propertyData, setPropertyData] = useState(null);
  const [bidOfferData, setBidOfferData] = useState();
  const [bidDetails, setBidDetails] = useState(null);
  const [buyerDetailsList, setBuyerDetailsList] = useState(null);
  const [dateTime, setDateTime] = useState(new Date());
  const [showHistory, setShowHistory] = useState(false);
  const [soldPropertiesData, setSoldPropertiesData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [bidOfferDetailList, setBidOfferDetailList] = useState([]);
  const [bidIds, setBidIds] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingFirstPage, setLoadingFirstPage] = useState(false);
  const loader = useRef(null);
  const [refreshData, setRefreshData] = useState(false);
  const [previousBidsList, setPreviousBidsList] = useState();
  const [previousBidsBuyerList, setPreviousBidsBuyerList] = useState();
  const [isFilterSelected, setIsFilterSelected] = useState();
  const [selectedEmail, setSelectedEmail] = useState('All');
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const state = store.getState();
  const userEmail = state?.user?.user?.userEmailId;

  // Simulate an API fetch
  const fetchBidList = async (pageNum, emailOverride = selectedEmail) => {

    console.log('emailOverride ', emailOverride)

    setLoadingFirstPage(true);

    const bidOfferResponse = await getBidOfferDetails({
      filterSelected: isFilterSelected ? "Y" : 'N',


      buyerEmailId: emailOverride === 'All' ? null : emailOverride === 'Self' ? userEmail : emailOverride,
      listingType: "AUCN",
      propertyStatus: null,
      // filterSelected: "N",
      // buyerEmailId: null,
      propertyAddress: "",
      type: "",
      pageNo: pageNum,
    });

    if (bidOfferResponse) {
      setLoadingFirstPage(false);

    }
    return bidOfferResponse?.bidOfferDetailList;
  };



  useEffect(() => {


    const loadItems = async () => {


      if (loadingFirstPage || !hasMore) return;

      setLoadingFirstPage(true);


      try {
        if (!showHistory) {
          const newItems = await fetchBidList(page);


          if (newItems?.length > 0) {
            setBidOfferDetailList((prev) => [...prev, ...newItems]);
          }

          if (newItems?.length < 8 || newItems === null) {


            setHasMore(false);
          }
        }

      } catch (error) {
        console.error('Error fetching items:', error);
      } finally {
        setLoadingFirstPage(false);
         if (isInitialLoad) {
         setIsInitialLoad(false);
         }
      }
    };

    loadItems();
  }, [page]);


  useEffect(() => {

    const loadBuyerList = async () => {


      const bidOfferDetailListResponse = await getBuyerFilterDetails();
      console.log('buyerDetailsList 1', bidOfferDetailListResponse)

      if (bidOfferDetailListResponse) {
        console.log('buyerDetailsList', bidOfferDetailListResponse)
        setBuyerDetailsList(bidOfferDetailListResponse.buyerDetailsList);

      }

    }





    const loadCifDetails = async () => {

      const ids = bidOfferDetailList.map(
        (item) => item.bidOfferSummary.bidOfferId
      );

      const newCifData = await getCifDetails(ids);

      setCifData(newCifData);
      setLoading(false);
    };

    loadBuyerList();

    loadCifDetails();
  }, [bidOfferDetailList]);

  const handleObserver = useCallback((entries) => {
    if (loadingFirstPage) return;

    const target = entries[0];

    if (target.isIntersecting && hasMore && !loadingFirstPage && !isInitialLoad) {
      // if (loadingFirstPage) return
      setPage((prev) => prev + 1);
      //setPage(page + 1);
    }
  }, [hasMore, loadingFirstPage, isInitialLoad]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (loader.current) observer.observe(loader.current);
    return () => observer.disconnect();
  }, [handleObserver]);


  const handleBuyerSelection = async (e) => {

    var email = e.target.value;

    setSelectedEmail(email);
    setIsFilterSelected('Y')

    resetPageNumber(email);

  }

  const resetPageNumber = async (email) => {

    console.log('email ', email)

    const pageNum = 1;
    setPage(pageNum);
    setHasMore(true);

    const newItems = await fetchBidList(pageNum, email);

    // const newItems = await fetchBidList(1, email);
    console.log('Fetched items:', newItems);
    setBidOfferDetailList(newItems);

    if (newItems?.length < 8 && newItems === null) {
      setHasMore(false);
    }
  }

  const getHistoryData = async () => {
    try {
      !showHistory
        ? trackButtonClick({
          eventName: "previous_transaction_click",
          eventCategory: "My Bids",
          eventSource: "on previous transaction click",
        })
        : trackButtonClick({
          eventName: "active_transaction_click",
          eventCategory: "My Bids",
          eventSource: "on active transaction click",
        });
      setShowHistory(!showHistory);
      // if (!showHistory) {
      // const data = await getSoldPropertiesDetails();
      // setPreviousBidsBuyerList(data?.buyerDetailsList);
      // const bidOfferResponse = await getBidOfferDetails({
      //   listingType: "AUCN",
      //   propertyStatus: null,
      //   filterSelected: "Y",
      //   buyerEmailId: email === 'All' ? null : email === 'Self' ? userEmail : email,
      //   propertyAddress: "",
      //   type: "PREVIOUS",
      // });


      // setPreviousBidsList(bidOfferResponse?.bidOfferDetailList);

    } catch (error) {
      console.error(error);
    }
  };



  const fetchBidDetails = async (bidId) => {
    try {
      setError(null);
      const data = await getBidDetailsById(bidId);

      setBidDetails(data);
    } catch (err) {
      setError("Failed to fetch bid details");
    } finally {
      // setLoading(false);
    }
  };
  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error.message}</div>;


  const renderBidsData = () => {
    return (
      <div >
        {
        buyerDetailsList?.length > 0 &&
          <Row className="pl30">
            <Col xs={3} md={1} >
              <p className="buyer-list">By Buyer</p>
            </Col>
            <Col xs={9} md={10} >
              <Form.Select
                className="w-50 w-sm-20"
                // value={selectYesBackupBid}
                onChange={handleBuyerSelection}

              >
                <option value="All" className="dropDownOptions">All</option>
                <option value="Self" className="dropDownOptions">Self</option>

                {(
                  buyerDetailsList
                )?.map((item) => (
                  <option className="dropDownOptions" key={item?.buyerEmailId} value={item?.buyerEmailId}>
                    {item.buyerFirstName + " " + item.buyerLastName}
                  </option>
                ))}
              </Form.Select>
            </Col>



          </Row >
        }

        {
          loading ? (
             <div className="text-center p-4 mt30">
                  <div className="mt30 pt30" role="">
                    <Loader />
                  </div>
                </div>
            // <div className="p-4">
            //   {[...Array(3)].map((_, index) => (
            //     <div key={index} className="mb-4 cfd-shimmer-wrapper">
            //       <ShimmerContentBlock
            //         title
            //         text
            //         cta
            //         thumbnailWidth={180}
            //         thumbnailHeight={100}
            //       />
            //     </div>
            //   ))}
            // </div>
          ) : (
            <>
           {(!bidOfferDetailList || bidOfferDetailList?.length === 0)? (

      <div className="text-center mt-4">
        Currently you do not have active bids on any of the properties
      </div>)

  :
            <div className="mx-0 mx-sm-4 mt-4">
              <div className="p-3 d-none d-sm-block" style={{ borderBottom: "1px solid #cccc" }}>
                {" "}
                <Row>
                  <Col xs={2} md={2}>
                    <p className="colHeading">Property Details</p>
                  </Col>
                  <Col xs={4} md={4}>
                    <p className="colHeading pl20" >Address</p>
                  </Col>
                  <Col xs={3} md={3}>
                    <p className="colHeading" style={{ textAlign: 'left' }}>Status</p>
                  </Col>
                  <Col xs={3} md={3}>
                    <p className="colHeading pr30" style={{ textAlign: 'right' }}>Actions</p>
                  </Col>
                </Row>
              </div>
              <div className="px-0 p-sm-3" style={{ borderBottom: "1px solid #cccc" }}>
                <PropertyDetailsCard
                  bidsData={bidOfferData}
                  bidOfferDetailList={bidOfferDetailList}
                  bidDetailsById={bidDetails}
                  componentType="bids"
                  cifDeatils={cifData}
                  resetPageNumber={resetPageNumber}
                // loading={loading}
                />
              </div>
            </div>
           }
            </>
          )
        }



      </div >
    )

  }

  return (
    <DashboardSectionWrapper title="My Bids"
      myBidsOrOfferToggleText={showHistory ? "Go Back" : "History"}
      handleToggleBidOrOfferHistory={() => {
        getHistoryData();
      }}
      showBidOrOfferToggleBtn>
      <div>
        <div>
          <div className="lastUpdated mb-3 mb-md-0">
            Last Updated:{" " + format(dateTime, 'MMM dd, yyy kk:mm:ss') + ' ET'}
          </div>
        </div>

        {

          showHistory ?
            <SoldProperties
              bidsData={bidOfferData}
              bidOfferDetailList={previousBidsList}
              bidDetailsById={bidDetails}
              componentType="bids"
              cifDeatils={cifData}
              showHistory={showHistory}
            />

            :

            renderBidsData()
        }



        <div ref={loader} style={{ height: '50px', textAlign: 'center' }}>

        </div>
      </div >
    </DashboardSectionWrapper >
  );
};

export default MyBids;
